import { action } from "mobx";
import { observer } from "mobx-react";
import { useEffect } from "react";
import ReactDOM from "react-dom";
import { useViewState } from "../Context";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Defines a portal with given id that can be attached by calling <PortalChild portalId={id} />
 */
export const Portal = _ref => {
  let {
    id,
    className
  } = _ref;
  const viewState = useViewState();
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  useEffect(action(() => {
    viewState.portals.set(id, document.getElementById(id));
    return action(() => {
      viewState.portals.delete(id);
    });
  }), [id, className]);
  return /*#__PURE__*/_jsx("div", {
    id: id,
    className: className
  });
};
/**
 * Attach children to the <Portal> identified by portalId
 */
export const PortalChild = observer(_ref2 => {
  let {
    viewState,
    portalId,
    children
  } = _ref2;
  const container = viewState.portals.get(portalId);
  return container ? /*#__PURE__*/ReactDOM.createPortal(children, container) : null;
});